module.exports = __webpack_public_path__ + "img/artwork.91b48264.svg";